export class CreditChartsModel {
    studentScoreChart: any = {};
}
